import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loginUser, clearError } from '../authSlice';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  
  const { username, password } = formData;
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const { userToken, error, isLoading } = useSelector((state) => state.auth);
  const [sessionMessage, setSessionMessage] = useState('');

  useEffect(() => {
    if (userToken) {
      navigate('/');
    }
    
    if (location.state?.message) {
      setSessionMessage(location.state.message);
    }
    
    return () => {
      dispatch(clearError());
      setSessionMessage('');
    };
  }, [userToken, navigate, dispatch, location.state]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim()
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      return;
    }

    const result = await dispatch(loginUser({ username, password }));
    console.log('Login result:', result);
    
    if (loginUser.fulfilled.match(result)) {
      console.log('Login successful');
    } else {
      console.error('Login failed:', result.payload);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        {sessionMessage && (
          <div className="session-message">
            {sessionMessage}
          </div>
        )}
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={username}
              onChange={handleChange}
              required
              placeholder="Enter your username"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>
          <button 
            type="submit" 
            className="auth-button"
            disabled={isLoading || !username || !password}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p className="auth-switch">
          Don't have an account?{' '}
          <span onClick={() => navigate('/register')}>
            Register here
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;






